export default "__VITE_ASSET__CH6AJ3O2__"